const colors = {
    skyblue: "#49c6e5",
    lightblue: "#54defd",
    paperWhite: "#fffbfa",
    mossgreen: "8bd7d2",
    spearmint:"#00bd9b"
}

export default colors;